import { useState } from "react";
import classNames from "classnames";
import styles from "./style.module.scss";
import CustomTabs from "shared/components/common/customTabs";
import Policy from "shared/components/dashboard/policy";

const DashboardPolicies = () => {
  const [activeTab, setActiveTab] = useState<string>("disclaimer");

  const tabs = [
    { label: "Disclaimer", value: "disclaimer", type: "Disclaimer" },
    {
      label: "Terms of Service",
      value: "terms",
      type: "Terms and Conditions",
    },

    { label: "Fee Policy", value: "fee", type: "Fee Policy" },
    { label: "Getting Paid", value: "gettingPaid", type: "Getting Paid" },
    { label: "Shipping", value: "shipping", type: "Shipping and Local Pickup" },
    {
      label: "Obligations",
      value: "Obligations",
      type: "Buyer and Seller Obligations",
    },
  ];

  const handleTabChange = (tabValue: string) => {
    setActiveTab(tabValue);
  };

  const activePolicyType =
    tabs.find((tab) => tab.value === activeTab)?.type || "";

  return (
    <>
      <div className={classNames(styles.sectionContainer)}>
        <div>
          <CustomTabs
            tabs={tabs}
            fullWidthTabs
            defaultActiveTab="privacy"
            onTabChange={handleTabChange}
          />
        </div>
      </div>
      <div className={classNames(styles.sectionContainer, "mt-4")}>
        <div>{activePolicyType && <Policy type={activePolicyType} />}</div>
      </div>
    </>
  );
};

export default DashboardPolicies;
